import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AuthContext } from '@@/contexts/AuthContext';
import { InsightsApiClient } from '../../api/api-client';
import { ResultValue } from '@@/types/ApiResult';
import { Contact } from '@aws-sdk/client-connect';

export const useContact = (id: string) => {
  const { instanceData } = useContext(AuthContext);

  const fetchContact = async (): Promise<Contact> => {
    if (!instanceData?.instanceId) {
      throw new Error('Missing required context data');
    }

    const client = new InsightsApiClient();
    const result = await client.getContactById({
      instanceId: instanceData.instanceId,
      region: instanceData.region,
      contactId: id
    });

    if (!ResultValue.ok(result)) {
      throw new Error('Failed to fetch contacts');
    }

    return result.data.contact;
  };

  const { data, isLoading, error, refetch, isRefetching } = useQuery<Contact, Error>({
    queryKey: ['contacts', instanceData?.instanceId, instanceData?.region, id],
    queryFn: fetchContact,
    retry: 0
  });

  return {
    data: data,
    isLoading: isLoading,
    isRefetching: isRefetching,
    error,
    refetch
  };
};
